
const AdminCommissionForm = function(element) {
    this.element = $(element);
    this.form = this.element.closest('form');
    this.changed = false;
    this.refreshUrl = this.element.attr('data-refresh-url');

    this.form.ajaxForm({
        success: response => {
            this.changed = false;

            Notifications.messages(response.messages);

            if (response.success) {
                this.refreshForm();
            }

            this.form.formLoading();
        }
    });

    // Refresh on modal succes
    this.form.on('form-success.modal', '[data-toggle="ajax-modal"]', event => {
        this.refreshForm();
    })

    // Prevent modal refresh if changed
    this.form.on('change', 'input', event => {
        this.changed = true;
    });
    this.form.on('modal-show.modal', '[data-toggle="ajax-modal"]', event => {
        if (this.changed) {
            Notifications.warning('Des taux ont été modifiés dans le tableau. Merci de sauvegarder avant de continuer.');

            event.preventDefault();
        }
    });
}

$.extend(AdminCommissionForm.prototype, {
    refreshForm: function() {
        this.form.addClass('loading');

        $.ajax({
            url: this.refreshUrl,
            success: response => {
                const newForm = $(response).find('form');

                this.form.html(newForm.html());
                this.form.removeClass('loading');
            }
        })
    }
});

$.fn.adminCommissionForm = function() {
    $.each(this, (index, element) => {
        new AdminCommissionForm(element);
    });
}


// WEBPACK FOOTER //
// ./js/form/commissions.js